<script setup>
import { useMainStore } from '../stores/main-store'
import FilterPopup from './FilterPopup.vue'
import AttributeList from './AttributeList.vue'
import SearchInput from './SearchInput.vue'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const mainStore = useMainStore()

const removeFilters = () => {
  mainStore.removeFilters()
  mainStore.removeSearchQuery()
  mainStore.categorySections = mainStore.apiData.products
}
</script>

<template>
  <Transition name="slide-fade">
    <FilterPopup v-if="mainStore.filterPopup">
      <SearchInput />
      <div class="grid fix-gap-sm">
        <AttributeList
          class="g-col-12 g-col-sm-6 g-col-lg-4 g-col-xl-3 fix-gap-sm"
          :attribute="mainStore.apiData.cats[0]"
          name="selectedCategories"
        />
        <AttributeList
          v-for="attribute in mainStore.apiData.atts"
          :key="attribute.slug"
          class="g-col-12 g-col-sm-6 g-col-lg-4 g-col-xl-3 fix-gap-sm"
          :attribute="attribute"
          name="selectedAttributes"
        />
      </div>
      <button
        type="button"
        class="lavnosrad-btn"
        @click="mainStore.filterPopup = false"
      >
        <span class="vn-a-content">{{ __('Search', 'lavnosrad') }}</span>
        <span class="vn-a-icon"><span></span></span>
      </button>
    </FilterPopup>
  </Transition>
  <button
    v-if="mainStore.hasFilter || mainStore.filterQuery !== ''"
    type="button"
    class="filter-opener filter-opener--remove"
    @click="removeFilters"
  >
    <i class="vn-icons-remove-filter"></i>
    <span>{{ __('Remove filters', 'lavnosrad') }}</span>
  </button>
  <button
    type="button"
    class="filter-opener"
    @click="mainStore.filterPopup = !mainStore.filterPopup"
  >
    <i class="vn-icons-filter"></i>
    <span>{{ __('Search for a work', 'lavnosrad') }}</span>
  </button>
</template>

<style lang="scss">
@import '../scss/product-filter';
</style>
